import React from 'react';
import Typography from '@mui/material/Typography';
import { getTypographyColorProps } from './getTypographyColorProps';
import { renderHeadingTextWithEmphasis } from './renderHeadingTextWithEmphasis';

const Heading2Large = (props) => {
  const {
    color,
    children,
    underline: _underline,
    uppercase: _uppercase,
    ...rest
  } = props;
  const { typographyColor, colorStyle } = getTypographyColorProps(color);
  const formattedChildren = renderHeadingTextWithEmphasis(children, color);
  return (
    <Typography
      {...rest}
      component="h2"
      color={typographyColor}
      sx={[
        {
          fontSize: '60px',
          fontWeight: '600',
          lineHeight: '66px',
        },
        colorStyle,
        ...(Array.isArray(rest.sx) ? rest.sx : [rest.sx]),
      ]}
    >
      {formattedChildren}
    </Typography>
  );
};

export default Heading2Large;
